import * as Constants from "../constants";

const initialState = {
  list: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
  case Constants.LICENSE_KEY_LIST_SUCCESS:
    return {
      ...state,
      list: action.payload,
    };
  default:
    return state;
  }
}
